import { defineLocale } from 'ngx-bootstrap/chronos';
import { daLocale, deLocale, enGbLocale, frLocale, nbLocale, nlLocale, svLocale } from 'ngx-bootstrap/locale';

export interface Culture {
  language: string;
  isoCode: string;
  name: string;
}

defineLocale('da', daLocale);
defineLocale('en', enGbLocale);
defineLocale('sv', svLocale);
defineLocale('nb', nbLocale);
defineLocale('de', deLocale);
defineLocale('fr', frLocale);
defineLocale('nl', nlLocale);

export const cultures: Culture[] = [
  { isoCode: 'da-DK', name: 'Dansk', language: 'da' },
  { isoCode: 'en-US', name: 'English', language: 'en' },
  { isoCode: 'sv-SE', name: 'Svenska', language: 'sv' },
  { isoCode: 'nb-NO', name: 'Norsk', language: 'nb' },
  { isoCode: 'de-DE', name: 'Deutsch', language: 'de' },
  { isoCode: 'fr-FR', name: 'Français', language: 'fr' },
  { isoCode: 'nl-NL', name: 'Nederlands', language: 'nl' },
];
